/*
 * Do not remove or alter the notices in this preamble.
 * This software code regards iO Custom Software.
 * Copyright © 2026 iO The Netherlands B.V. and/or its affiliates.
 * www.iodigital.com All rights reserved. License grant and user rights and obligations
 * according to applicable license agreement. Please contact legal@iodigital.com for
 * questions regarding license and user rights.
 */

import { StateCreator } from 'zustand';

import { StepEnum } from '@/api-sdk';

export type ValidationMessages = Partial<Record<StepEnum, string>>;

export interface ValidationState {
  validationMessages: ValidationMessages;
  showValidationSnackbar: boolean;
  showValidationMessage: boolean;
  setValidationMessages: (validationMessages: ValidationMessages) => void;
  setShowValidationMessage: () => void;
  setShowValidationSnackbar: (showValidationSnackbar: boolean) => void;
  getValidationSnackbarContent: () => string | undefined;
}

export const validationStore: StateCreator<ValidationState> = (set, get) => ({
  validationMessages: {},
  showValidationSnackbar: false,
  showValidationMessage: false,
  setValidationMessages: validationMessages => {
    set({ validationMessages });
  },
  setShowValidationMessage: () => {
    const { validationMessages } = get();

    const showValidationMessage =
      Object.values(validationMessages).some(Boolean);

    set({
      showValidationMessage: showValidationMessage,
      showValidationSnackbar: showValidationMessage,
    });
  },
  setShowValidationSnackbar: showValidationSnackbar => {
    set({
      showValidationSnackbar: showValidationSnackbar,
    });
  },
  getValidationSnackbarContent: () => {
    const { validationMessages } = get();
    return Object.values(validationMessages).find(
      message => message !== null && message !== undefined,
    );
  },
});
